import { createAction } from '@reduxjs/toolkit';


export const authenticated = createAction('customer/authenticated');
export const addToken = createAction('customer/add_token');
export const addCustomerData = createAction('customer/add_data');
export const addAdresses = createAction('customer/add_adresses');
export const updateAdresses = createAction('customer/update_adresses');
export const addAddress = createAction('customer/add_address');
export const addOrders = createAction('customer/add_order');
export const logout = createAction('customer/logout');
